import * as React from 'react';
import i18n from 'i18next';
import {
    blackListTunables,
    headerTunables,
    labelTunables,
    metricValueTunables,
    opacityTunables,
    percentChangeTunables,
    sizingTunables,
    textFormatTunables,
} from 'components/Sidebar/RenderTunables/SharedTunables';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import { Widget } from '@sprinklr/stories/widget/Widget';

const TwitterWidgetTunables = (widget: Widget): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Tree Map'),
            startOpen: true,
        } as CollapseProps,
        children: [...headerTunables(widget, { header: true }), opacityTunables(widget)],
    },
    {
        props: {
            label: i18n.t('Labels'),
            startOpen: true,
        },
        children: [
            labelTunables(widget),
            ...textFormatTunables(widget, { fit: true, clamp: true, wrap: true }),
            ...metricValueTunables(widget, {
                value: { enable: true, size: true },
                format: true,
                name: true,
                change: true,
            }),
            ...percentChangeTunables(widget),
        ],
    },
    sizingTunables(widget, { spacing: { max: 15 }, padding: { min: 5, max: 20 } }),
    {
        props: {
            label: i18n.t('Tunables'),
            startOpen: false,
        } as CollapseProps,
        children: [blackListTunables(widget)],
    },
];

export default TwitterWidgetTunables;
